<script>
export default {};
</script>
<template><div>custom</div></template>
